import { render, staticRenderFns } from "./TestQuestionCount.vue?vue&type=template&id=1dd22910&scoped=true&"
import script from "./TestQuestionCount.vue?vue&type=script&lang=js&"
export * from "./TestQuestionCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd22910",
  null
  
)

export default component.exports